<template>
  <div class="message a-message is-flex" :class="{'their-message': !fromUser(message), 'my-message': fromUser(message), 'has-text-grey-light': deletedUser}">
    <!-- Edit message icon -->
    <div>
      <div v-if="checkEditMessagePermission" @click="editMessage(message)" class="cog adjust-alignment" :class="{'admin-edit': checkEditMessagePermission && !(myMessage(message.sender.userName)), 'adjust-alignment' : showTrash}">
        <span><i class="fal fa-cog"></i></span>
      </div>
      <div v-if="showTrash" @click="showDeleteModal" class="trash admin-edit">
        <span><i class='fal fa-trash-alt'></i></span>
      </div>
      <div v-if="showReportFlag" class="flag">
        <report :message="message" tooltipDir="up-right"></report>
      </div>
    </div>
    <!-- Like button -->
    <div class="meta-likes meta-data" :class="{'meta-likes-active': hasLiked}" v-if="!editMode">
      <div class="likes" @mouseenter="showLikes" @mouseleave="hideLikes">
        <span class="icon" @click="canLike()"><i class="fa-thumbs-up" :class="{far: hasLiked, fal: !hasLiked}"></i></span>
        <span class="count" v-if="message.metadata.likes > 0">{{message.metadata.likes}}</span>
        <span class="dropper" v-if="dropdowns.likes.show && !isTouch && message.metadata.likes > 0">
            <drop-down :users="dropdowns.likes.users" :loading="dropdowns.likes.loading" @fetch="fetchLikedBy" @close="hideLikes"></drop-down>
        </span>
      </div>
    </div>
    <!-- Avatar -->
    <div class="avatar-timestamp is-flex">
      <div class="user-avatar" @click="viewProfile(message.sender.userName)">
        <img :src="thumbnail(message.sender.avatar)" :alt="message.sender.userName">
      </div>
      <div class="timestamp" :data-balloon="formatTimestamp(message.sentAt)" data-balloon-pos="down" data-balloon-length="small">{{formattedDate(message.sentAt)}}</div>
    </div>
    <div class="message-content">
      <div class="a-message-username" @click="viewProfile(message.sender.userName)">{{message.sender.userName}}
        <span v-if="message.sender.isEngStaff" class="staff-shield"><i class="fal fa-shield-check"></i></span>
        <span v-if="deletedUser" class="deleted-user is-size-7 is-pulled-right">{{ $t('messaging.removedUser') }}</span>
      </div>

      <!-- Edit mode -->
      <div v-if="editMode" class="a-message-content">
        <message-textarea v-bind:class="{'disabled': !showSaveButton}" ref="editMessageEditor" v-model="newMessage" :maxLength="maxLength" @input="onChange"> </message-textarea>
        <div class="edit-buttons is-flex">
          <div class="save-or-cancel">
            <button v-if="showSaveButton" class="button is-outlined is-primary" @click="saveMessage" v-bind:disabled="newMessageLength > 2000 || newMessageLength === 0">Save</button>
            <button class="button is-outlined" @click="toggleEdit">{{ $t('cancel') }}</button>
          </div>
          <div class="help is-danger">{{error}}</div>
          <button class="button is-danger" :class="{'is-loading': deleting,
            'is-outlined': !deleting }" @click="showDeleteModal">{{ $t('messaging.delete') }}</button>
        </div>
        <span v-if="blankMessage" class="blank-comment"> {{blankMsg}} </span>
      </div>

      <!-- View mode -->
      <div v-if="!editMode" class="a-message-content">
        <html-view :content="message.message"></html-view>
      </div>
      <div v-if="message.sentAt !== message.updatedAt && !editMode" class="edited">(edited)</div>

    </div>
  </div>
</template>

<script>

import HtmlView from '@/components/Controls/HTMLView'
import MessageTextarea from '@/components/Inputs/QuillEditor'
import DropDown from '@/components/Controls/MetaCountsDropdown'
import dropDownMixin from '@/components/Controls/MetaCountsDropdown/mixin'
import Report from '@/components/UIReport'

import imageProxy from '@/libs/image-proxy'
import userAgent from '@/libs/user-agent'

import auth from '@/mixins/auth'

import moment from 'moment'
import throttle from 'lodash/throttle'

import i18n from '@/i18n'
import componentState from '@/mixins/component-state'
import state from '@/components/SectionProjectView/state'
export default {
  props: ['message', 'conversationID', 'deletedUser', 'isSupervisor', 'chatType'],

  components: {
    HtmlView,
    MessageTextarea,
    DropDown,
    Report
  },
  mixins: [auth, dropDownMixin, componentState],

  data: function () {
    return {
      deleting: false,
      editMode: false,
      edited: '',
      blankMessage: false,
      blankMsg: i18n.t('messaging.cannotBeEmpty'),
      error: '',
      currMessage: '',
      newMessage: '',
      newMessageLength: 0,
      backupMessage: '',
      maxLength: 2000,
      dropdowns: {
        likes: dropDownMixin.initDropdown()
      }
    }
  },

  computed: {
    isTouch: function () {
      return userAgent.isIOS() || userAgent.isAndroid()
    },
    charactersRemaining: function () {
      return 2000 - this.newMessage.length
    },
    hasLiked: function () {
      return this.isLoggedIn ? this.$store.getters.likedMessage(this.message.id, this.currentUser.userName) : false
    },
    isConversationPublic: function () {
      return this.$store.getters.isConversationPublic(this.conversationID)
    },
    showEditCog: function () {
      return (this.myMessage(this.message.sender.userName) || this.isAdmin) && !this.editMode
    },
    showCogByRole: function () {
      return this._get(state.project.permissions.liveChat) && this.chatType === 'LiveChat'
    },
    showAdminCog: function () {
      return this.isAdmin && this.chatType !== 'LiveChat'
    },
    showTrash: function () {
      return !this.showEditCog && this.isSupervisor
    },
    showReportFlag: function () {
      return !this.myMessage(this.message.sender.userName)
    },
    showSaveButton: function () {
      return this.myMessage(this.message.sender.userName) || this.isAdmin
    },
    checkLiveChatUserRole: function () {
      return (this.userLiveChatRole === 'co-owner' || this.userLiveChatRole === 'owner' || this.userLiveChatRole === 'anonAdmin' || this.userLiveChatRole === 'admin') && this.userChatType === 'LiveChat'
    },
    userChatType: function () {
      return this._get(state.project.chatType)
    },
    userLiveChatRole: function () {
      return this._get(state.project.role)
    },
    checkEditMessagePermission: function () {
      return this.showEditCog || this.showCogByRole || this.checkLiveChatUserRole
    }
  },

  mounted: function () {
    this.checkLiked()
  },

  updated: function () {
    this.checkLiked()
  },

  methods: {
    fetch: function (type, method) {
      const params = { id: this.message.id, limit: 10, offset: this.dropdowns[type].offset }
      return this.fetchDropdown(type, method, params)
    },
    fetchLikedBy: function () {
      return this.fetch('likes', 'messageLikedBy')
    },
    showLikes: function () {
      return this.showDropdown('likes')
    },
    hideLikes: function (event) {
      return this.hideDropdown('likes', event)
    },
    checkLiked: function () {
      if (!this.isLoggedIn) {
        return
      }

      const data = {
        id: this.message.id,
        username: this.currentUser.userName
      }

      this.$store.dispatch('likedMessage', data)
    },
    canLike: function () {
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'communitymessagelike', onSuccess: this.like, signupMessage: 'To like ' + this.message.sender.userName + '\'s message' })
      }
      this.like()
    },
    like: throttle(function () {
      const data = {
        id: this.message.id,
        username: this.$store.getters.currentUser.userName,
        conversationId: this.conversationID
      }
      if (this.hasLiked) {
        this.$store.dispatch('unlikeMessage', data)
      } else {
        this.$store.dispatch('likeMessage', data)
      }
    }, 500, { leading: true, trailing: false }),
    formattedDate: function (timestamp) {
      const date = moment(timestamp)
      // no future comments
      if (date.isAfter(moment())) {
        return moment().fromNow()
      }
      if (date.isBefore(moment().subtract(2, 'days'))) {
        return date.format('MMM D, YYYY')
      } else {
        return date.fromNow()
      }
    },
    viewProfile: function (userLink) {
      this.$emit('saveState')
      this.$router.push({ name: 'profile', params: { username: userLink } })
    },
    editMessage: function (message) {
      this.currMessage = this.message.message
      this.backupMessage = this.currMessage
      this.newMessage = this.backupMessage
      this.toggleEdit()
    },
    saveMessage: function () {
      this.currMessage = this.newMessage
      if (this.currMessage === this.backupMessage) {
        return this.toggleEdit()
      }
      if (this.currMessage.trim() === '') {
        this.blankMessage = true
        return true
      }

      this.$store.dispatch('updateMessage', { conversationID: this.conversationID, messageID: this.message.id, message: this.newMessage }).then((response) => {
        this.toggleEdit()
        this.edited = true
      }, () => {
        this.error = 'Unable to update message'
      })
    },
    toggleEdit: function () {
      this.editMode = !this.editMode
      this.$emit('toggleEdit')
      this.blankMessage = false
    },
    myMessage: function (messenger) {
      if (this.$store.getters.currentUser.userName === messenger) {
        return true
      }
    },
    showDeleteModal: function () {
      this.$emit('showModal', this.message.id, this.showCogByRole)
    },
    fromUser: function (message) {
      return message.sender.uuid === this.$store.getters.currentUser.uuid
    },
    thumbnail: imageProxy.thumbnail,
    formatTimestamp: function (timestamp) {
      const date = moment(timestamp)
      return date.format('DD-MM-YY, HH:mm:ss')
    },
    onChange: function (text) {
      this.newMessageLength = this.$refs.editMessageEditor.quillText ? this.$refs.editMessageEditor.quillText.trim().length : 0
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .a-message {
    display: flex;
    padding: 10px;
    background-color: whitesmoke;
    position: relative;
    .user-avatar{
      width: 25%;
      height: 40px;
      max-width: 40px;
      min-width: 40px;
      margin: 5px 10px;
      img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 50%;
        height: 100%;
        width: 100%;
      }
      cursor: pointer;
    }
    .avatar-timestamp{
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 70px;
    }
    .timestamp{
      max-width: 70px;
      margin-top: 0px;
      font-size: 0.6rem;
      color: gray;
      text-align: center;
    }
    .message-content{
      margin: 0 5px 20px 5px;
      font-size: 0.9rem;
      max-width: 75%;
      min-width: 75%;
      width: 75%;
      .deleted-user {
        margin-right: 0.5rem;
      }
    }
    .a-message-username{
      font-weight: 500;
      cursor: pointer;
    }
    .a-message-content{
      word-wrap: break-word;
    }
  }
  .their-message{
    margin: 0.55rem;

  }
  .my-message{
    margin-bottom: 0.25rem;
    margin-left: 33%;
    .dropper {
      position: relative;
      margin-left: -10rem;
      display: block;
    }
  }
  .their-message, .my-message{
    width: 65%;
    background-color: white;
    margin-top: 1rem;
    border-radius: 1rem;
    @include mobile{
      width: 100%;
      margin: 0;
      border-bottom: 1px solid lightgrey;
      border-radius: 0;
    }
  }
  .cog, .trash {
    position: absolute;
    right: 1rem;
    top: 0.5rem;
    cursor: pointer;
    color: grey;
    font-size: 0.9rem;
  }
  .admin-edit {
    right: 3rem;
  }
  .flag {
    position: absolute;
    right: 1rem;
    top: 0.5rem;
    cursor: pointer;
    color: grey;
    font-size: 0.9rem;
  }
  .edit-buttons{
    justify-content: space-between;
    margin-top: 0.5rem;
    button {
      border-radius: 0;
    }
  }
  .edited {
    font-size: 0.7rem;
    color: $grey-light;
  }
  .meta-likes {
    display: flex;
    align-self: flex-end;
    align-items: flex-end;
  }
  .likes {
    vertical-align: middle;
    position: absolute;
    right: 0.8rem;
    bottom: 0.5rem;
    margin-top: 1rem;
    .count {
      position: absolute;
      font-size: 0.9rem;
      bottom: 0;
      right: 27px;
      margin-top: 0.5rem;
    }
    .icon {
      position: absolute;
      bottom: 0;
      right: 0;
      cursor: pointer;
      margin-top: 0.5rem;
    }
    .dropper {
      position: relative;
      margin-left: -6rem;
      display: block;
      @include mobile {
        margin-left: -10rem;
      }
    }
  }
  .my-message{
    .dropper {
      position: relative;
      margin-left: -10rem;
      display: block;
    }
  }
  .meta-likes-active {
    color: $primary;
  }

  .char-count {
    font-size: 0.8rem;
    color: lightgray;
    &.exceeded {
      color: $danger;
    }
  }

  .textarea {
    height: 90px;
  }
</style>

<style lang="scss">
@import '~styles/utils.scss';

.message a {
  color: #00ADEE !important; // over-riding default Bulma styles
}
.disabled {
  opacity: 0.8;
  pointer-events: none;
}

.adjust-alignment {
  margin-right: 1.8rem;
}

</style>
